// Native bridge for Capacitor DirectCall plugin
// This allows the web app to use native Android calling

const DirectCall = {
  // Check if we're running in Capacitor native app
  isNative: () => {
    return window.Capacitor && window.Capacitor.isNativePlatform();
  },

  // Make a direct call (no dialer UI, calls immediately)
  call: async (phoneNumber) => {
    if (!DirectCall.isNative()) {
      console.log('Not in native app, falling back to tel: link');
      window.location.href = `tel:${phoneNumber}`;
      return { success: false, reason: 'not_native' };
    }

    try {
      const { DirectCall: NativeDirectCall } = window.Capacitor.Plugins;
      if (NativeDirectCall) {
        const result = await NativeDirectCall.call({ phoneNumber });
        console.log('Direct call result:', result);
        return result;
      } else {
        console.log('DirectCall plugin not available');
        window.location.href = `tel:${phoneNumber}`;
        return { success: false, reason: 'plugin_not_available' };
      }
    } catch (error) {
      console.error('Direct call error:', error);
      // Fallback to tel: link
      window.location.href = `tel:${phoneNumber}`;
      return { success: false, error: error.message };
    }
  },

  // Open dialer with number pre-filled (shows dialer UI)
  openDialer: async (phoneNumber) => {
    if (!DirectCall.isNative()) {
      window.location.href = `tel:${phoneNumber}`;
      return;
    }

    try {
      const { DirectCall: NativeDirectCall } = window.Capacitor.Plugins;
      if (NativeDirectCall) {
        await NativeDirectCall.openDialer({ phoneNumber });
      } else {
        window.location.href = `tel:${phoneNumber}`;
      }
    } catch (error) {
      window.location.href = `tel:${phoneNumber}`;
    }
  }
};

export default DirectCall;
